import {useIntl} from '@sail/intl';
import {useSelector} from 'src/v2/state/store';
import {formatCurrencyAmountToMajorUnitsFixed} from 'src/utils/helpers';
import {formatAssetCode} from 'src/v2/util/formatAssetCode';

export const useAmountDisplay = (): string => {
  const intl = useIntl();

  const currency = useSelector((state) => state.paymentDetails.currency);
  const originalAmount = useSelector(
    (state) => state.paymentDetails.originalAmount,
  );
  const originalCurrency = useSelector(
    (state) => state.paymentDetails.originalCurrency,
  );
  const enablePayWithAnyCrypto = useSelector(
    (state) => state.featureFlags.enable_pay_with_any_crypto,
  );
  const selectedCurrencyAssetCode =
    useSelector(
      (state) =>
        state.selectedCurrency?.assetCode ??
        state.directDeposit.selectedDirectDepositCurrency,
    ) || 'usdc';
  const adjustedAmount = useSelector((state) => state.paymentDetails.amount);

  const hasOriginalAmount =
    originalAmount !== null && originalCurrency !== null;

  if (enablePayWithAnyCrypto) {
    if (hasOriginalAmount) {
      return intl.formatCurrency(originalAmount, {
        currency: originalCurrency,
        style: 'symbol',
      });
    }
    return intl.formatCurrency(adjustedAmount, {currency, style: 'symbol'});
  }

  const cryptoPrefix = formatAssetCode(selectedCurrencyAssetCode);
  const formattedDepositAmount = formatCurrencyAmountToMajorUnitsFixed(
    adjustedAmount,
    currency,
  );

  if (hasOriginalAmount) {
    // Using symbol style so there's no ambiguity about the currency. i.e. MX$100 vs $100
    const formattedOriginalAmount = intl.formatCurrency(originalAmount, {
      currency: originalCurrency,
      style: 'symbol',
    });
    return `${formattedOriginalAmount} → ${cryptoPrefix} ${formattedDepositAmount}`;
  }

  return `${cryptoPrefix} ${formattedDepositAmount}`;
};
